/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import __unplugin_components_9 from '~icons/ep/edit-pen';
import { ElInput as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElRow as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElCard as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/card/style/css';
import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_2 from '~icons/ep/upload-filled';
import { ElForm as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ea34fa4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = {
  class: "flex justify-between"
};
const _hoisted_3 = {
  class: "label"
};
const _hoisted_4 = {
  class: "upload"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传官方包", -1));
const _hoisted_6 = ["src"];
import { imgLimit } from '@ultra/share/utils';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { useAppStore } from '@/store/modules/app';
import { apiUsdkGetOfficialList, apiUsdkDelOfficialPackage, apiUsdkPackageSetRemark, apiUsdkGetMaxVersionOfficialPackage } from '@/api/usdk';
import { ellipsisHtml } from '@/utils/util';
import UploadPack from './uploadPack.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const columns = [{
      label: '编号',
      prop: 'id'
    }, {
      label: 'ICON',
      prop: 'icon',
      slot: 'icon'
    }, {
      label: '游戏名称',
      prop: 'gameName'
    }, {
      label: '游戏包名',
      prop: 'pkgName'
    }, {
      label: '渠道',
      prop: 'channelName'
    }, {
      label: '游戏版本',
      prop: 'verName',
      slot: 'verName'
    }, {
      label: '渠道SDK版本',
      prop: 'sdkResourceName'
    }, {
      label: 'MD5',
      prop: 'md5'
    }, {
      label: '备注',
      prop: 'remark'
    }, {
      label: '操作',
      action: true
    }];
    const uploadPackRef = ref();
    const paginationObj = ref({});
    const officialPack = ref({});
    const detailForm = ref({
      id: '',
      cname: '',
      pkgName: '',
      pkgAppName: '',
      verName: '',
      verCode: '',
      sdkResourceName: '',
      md5: '',
      remark: '',
      icon: '',
      gameName: '',
      channelName: '',
      channelVersionName: ''
    });
    const detailVisible = ref(false);
    const isEdit = ref(false);
    const remarkLoading = ref(false);
    const gameInfo = computed(() => useAppStore().gameInfo);
    const handleClick = (type, item) => {
      if (type === 'detail') {
        detailVisible.value = true;
        const data = JSON.parse(JSON.stringify(item));
        data.remark = data.remark && ellipsisHtml(data.remark);
        detailForm.value = data;
      } else if (type === 'del') {
        ElMessageBox.confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = [];
          if (item) {
            delete item.log;
            params.push(item);
          }
          apiUsdkDelOfficialPackage({
            id: item.id
          }).then(res => {
            if (res.code === 0) {
              handleOk();
            }
          });
        }).catch(() => {
          //
        });
      }
    };
    const handleDetailModalCancel = () => {
      detailVisible.value = false;
      isEdit.value = false;
    };
    const handleSaveRemark = () => {
      const params = {
        id: detailForm.value.id,
        remark: detailForm.value.remark
      };
      remarkLoading.value = true;
      apiUsdkPackageSetRemark(params).then(res => {
        if (res.code === 0) {
          isEdit.value = false;
          getTableData();
        }
      }).finally(() => {
        remarkLoading.value = false;
      });
    };
    // 获取最新渠道包
    const getLastOfficialPack = () => {
      apiUsdkGetMaxVersionOfficialPackage({
        gid: gameInfo.value.Id
      }).then(res => {
        if (res.code === 0) {
          officialPack.value = res.data;
        }
      });
    };
    const getTableData = () => {
      const params = {
        gid: gameInfo.value.Id
      };
      tableLoading.value = true;
      apiUsdkGetOfficialList({
        ...params,
        pageNumber: current.value,
        pageSize: pageSize.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data.list;
          total.value = res.data.totalRow;
          paginationObj.value = {
            pageNumber: res.data.pageNumber,
            pageSize: res.data.pageSize,
            totalPage: res.data.totalPage
          };
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    const handleUploadPackage = () => {
      uploadPackRef.value.show();
    };
    const handleOk = () => {
      getTableData();
      getLastOfficialPack();
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
        getLastOfficialPack();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_form = __unplugin_components_1;
      const _component_i_ep_UploadFilled = __unplugin_components_2;
      const _component_el_icon = __unplugin_components_3;
      const _component_el_card = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_col = __unplugin_components_6;
      const _component_el_row = __unplugin_components_7;
      const _component_el_input = __unplugin_components_8;
      const _component_i_ep_EditPen = __unplugin_components_9;
      const _component_el_dialog = __unplugin_components_10;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "width": "500px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最新官方包版本"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(officialPack).createTime || '暂无最新官方包'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "versionName："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(officialPack).verName || '无'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "versioncode："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(officialPack).verCode || '无'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(officialPack).remark || "无"), 1)]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
          class: "upload-pack",
          onClick: handleUploadPackage
        }, [_createVNode(_component_el_icon, {
          class: "icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_UploadFilled)]),
          _: 1
        }), _hoisted_5])])])]),
        _: 1
      })]), _createVNode(UTable, {
        options: columns,
        pagination: "",
        data: _unref(tableData),
        loading: _unref(tableLoading),
        class: "marginT20",
        "current-page": _unref(current),
        "page-size": _unref(pageSize),
        total: _unref(total),
        onSizeChange: _cache[0] || (_cache[0] = $event => (_unref(handleSizeChange), _unref(handleCurrentChange))),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        icon: _withCtx(({
          scope
        }) => [_createElementVNode("img", {
          style: {
            "width": "50px !important"
          },
          src: _unref(imgLimit)(scope.row.icon, 50),
          alt: ""
        }, null, 8, _hoisted_6)]),
        verName: _withCtx(({
          scope
        }) => [_createElementVNode("div", null, [_createElementVNode("div", null, "V" + _toDisplayString(scope.row.verName), 1), _createElementVNode("div", null, "Code:" + _toDisplayString(scope.row.verCode), 1)])]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('detail', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("详情")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "danger",
          onClick: $event => handleClick('del', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("删除")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading", "current-page", "page-size", "total", "onCurrentChange"]), _createVNode(_component_el_dialog, {
        title: `${_unref(detailForm).cname || ''} 详情`,
        modelValue: _unref(detailVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(detailVisible) ? detailVisible.value = $event : null),
        width: "600px",
        "before-close": handleDetailModalCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("包名：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detailForm).pkgName), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("游戏名：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detailForm).pkgAppName || '默认使用母包名称'), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("versionName：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detailForm).verName), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("versionCode：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detailForm).verCode), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("渠道SDK版本：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(`${_unref(detailForm).sdkResourceName}`), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("MD5：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(detailForm).md5), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            class: "flex-label",
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("备注：")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              disabled: !_unref(isEdit),
              placeholder: "请填写备注",
              modelValue: _unref(detailForm).remark,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(detailForm).remark = $event),
              autosize: {
                minRows: 3,
                maxRows: 5
              }
            }, null, 8, ["disabled", "modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "flex-line",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            offset: 6
          }, {
            default: _withCtx(() => [!_unref(isEdit) ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              class: "cp",
              size: 20,
              onClick: _cache[2] || (_cache[2] = $event => isEdit.value = true)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_EditPen)]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              loading: _unref(remarkLoading),
              onClick: handleSaveRemark
            }, {
              default: _withCtx(() => [_createTextVNode(" 保存 ")]),
              _: 1
            }, 8, ["loading"]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(UploadPack, {
        ref_key: "uploadPackRef",
        ref: uploadPackRef,
        "game-info": _unref(gameInfo),
        onOk: handleOk
      }, null, 8, ["game-info"])]);
    };
  }
});